import { render } from "./StartSequenceView.vue?vue&type=template&id=70b9cb76"
import script from "./StartSequenceView.vue?vue&type=script&lang=js"
export * from "./StartSequenceView.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__